import type { Design } from '@epilot/journey-logic-commons'
import { getOptimizedFileIdURL } from '@epilot/journey-logic-commons'

import { selectDesignBuilderState } from '../store/selectors/runtime'
import { IMAGE_PREVIEW_API_URL } from '../utils/config'

import { useAppStoreSelector } from './useAppStoreSelector'

const LOGO_HEIGHT = 30

function getLogoUrl(design?: Design) {
  if (!design) {
    return undefined
  }

  if (design.orgId && design.fileId) {
    return getOptimizedFileIdURL({
      apiUrl: IMAGE_PREVIEW_API_URL,
      orgId: design.orgId,
      fileId: design.fileId,
      height: LOGO_HEIGHT
    })
  }

  return design.logoUrl
}

export const useLogoUrl = (design?: Design) => {
  const designInfo = useAppStoreSelector(selectDesignBuilderState)

  // use the logo that is passed from Design Builder if it exists, otherwise use the logo from the journey
  // Design Builder theme is used to determine if the logo is from the Design Builder or the journey
  const logoUrl = designInfo ? designInfo?.logoUrl : getLogoUrl(design)

  return logoUrl
}
